(function tesModal() {
  'use strict';
  var $ = window.jQuery;

  $.fn.tesmodal = function createTesmodal(action, opts) {
    // Close on backdrop click by default;
    var backdropClose = opts && Boolean(opts.backdropClose) === opts.backdropClose ? opts.backdropClose : true;

    this.each(function tesmodalEach() {
      var $modal = $(this);
      var dialog = $modal.find('.tes-modal__dialog').get(0);

      if (typeof action === 'string') {
        $modal.trigger('tesmodal-' + action);
        return;
      }

      // init
      $modal.on('tesmodal-show', function tesmodalShow() {
        $modal.addClass('tes-modal--open');
        $(document.body).addClass('tes-modal--opened-container');
      });

      $modal.on('tesmodal-hide', function tesModalHide() {
        $modal.removeClass('tes-modal--open');
        $(document.body).removeClass('tes-modal--opened-container');
      });

      $modal.on('click', function tesModalClick(evt) {
        if ($(evt.target).is('.tes-modal__close')  || $(evt.target).is('.js-tes-modal__close') ) {
          $modal.trigger('tesmodal-hide');
        }
      });

      if (backdropClose === true) {
        $modal.on('click', function tesModalBackdropClick(evt) {
          if (!$.contains(dialog, evt.target)) {
            $modal.trigger('tesmodal-hide');
          }
        });
      }

      $(document).keyup(function tesModalKeyup(e) {
        if (e.keyCode === 27) { // escape key maps to keycode `27`
          $modal.trigger('tesmodal-hide');
        }
      });
    });

    return this;
  };
})();
